export default __webpack_public_path__ + "static/The Backdrop_image 5@2x-c8d83adab0ee78923f056aea827d0f5f.jpg";